const Style = {
    container: 'flex w-full gap-3 px-3 py-2.5',
    link: 'text-primary-600 underline',
    avatar: 'mt-0.5 hidden shrink-0 sm:inline-flex',

    frame: `min-w-0 flex-1 rounded-xl border border-border bg-surface shadow-sm transition-colors
        focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-ring/40`,

    // Auto-grows (see chat.js) between these bounds, then scrolls.
    textArea: `block max-h-60 min-h-[4.5rem] w-full resize-none overflow-y-auto rounded-t-xl border-0
        bg-transparent px-3.5 py-2.5 text-sm leading-relaxed text-text-primary placeholder:text-text-muted focus:outline-none
        disabled:cursor-not-allowed disabled:opacity-60`,
    submittingOverlay: 'absolute inset-0 flex items-center justify-center rounded-t-xl bg-muted/50',

    files: 'border-t border-border px-3.5 py-2',
    toolbar: 'flex items-center gap-2 border-t border-border px-2 py-1.5',
    // The send button sits hard right; attach stays left.
    spacer: 'ml-auto',

    placeholder: 'text-text-muted text-sm opacity-50',
    hint: 'hidden pr-1 text-[11px] text-text-muted md:inline',

    submitBtn: `inline-flex h-8 shrink-0 items-center justify-center gap-1.5 rounded-md bg-accent-500
        px-3 text-xs font-medium text-white transition-colors hover:bg-accent-600
        disabled:pointer-events-none disabled:opacity-50`,
    attachBtn: `inline-flex h-8 shrink-0 items-center justify-center gap-1.5 rounded-md px-2
        text-xs font-medium text-text-muted transition-colors hover:bg-muted hover:text-text-primary
        disabled:pointer-events-none disabled:opacity-50`,
    attachLabel: 'hidden sm:inline',
};

export default Style;
